import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { withNamespaces } from "react-i18next";

import { Modal, Button } from "react-bootstrap";
import Spinner from "../../../../components/Spinner";
import pagination from "~/components/pagination/currentSizePerPage/10";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ButtonAdd from "~/components/Buttons/AdicionarBtn";

import { deleteUser, requestUsers, clearDeleteUser } from "../actions";

const UnikUserTable = ({ users, t, addUser }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(undefined);

  const { isLoadingUsers, successDeleteUser } = useSelector(
    (state) => state.userManagementReducer
  );

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    if (successDeleteUser) {
      dispatch(requestUsers({ username: "" }));
      dispatch(clearDeleteUser());
    }
  }, [successDeleteUser]);

  const apagarUtilizador = () => {
    const payload = {
      id: selectedUser.id,
    };
    dispatch(deleteUser(payload));
    handleClose();
  };

  const openModal = (user) => {
    setSelectedUser(user);
    setShow(true);
  };

  const buildActionsColumn = (_, row, {}) => (
    <>
      <i
        className="icon-trash table-action-icon"
        onClick={() => openModal(row)}
      />
      <i
        className="icon-edit-user table-action-icon"
        onClick={() =>
          history.push(`/uniksystem/admin/edit-unikuser/${row.id}`)
        }
      />
    </>
  );

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "username",
      text: t("admin.userManagement.list.username"),
      sort: true,
    },
    {
      dataField: "firstName",
      text: t("admin.userManagement.list.name"),
      sort: true,
      formatter: (cell, row, rowIndex, extraData) => (
        <> {`${row.firstName} ${row.lastName}`} </>
      ),
    },
    {
      dataField: "lastName",
      hidden: true,
    },
    {
      dataField: "organizationName",
      text: t("admin.userManagement.list.organization"),
      formatter: (cell, row, rowIndex, extraData) => (
        <> {`${row?.organizationName || ""}`} </>
      ),
      sort: true,
    },
    {
      dataField: "accao",
      text: t("admin.userManagement.list.action"),
      formatter: buildActionsColumn,
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
  ];

  return (
    <>
      <div className="custom-table custom-table-small">
        <ToolkitProvider keyField="id" data={users} columns={columns} search>
          {(props) => (
            <div>
              <div style={{ paddingBottom: "20px", display: "flex" }}>
                <SearchBar
                  {...props.searchProps}
                  placeholder={t("admin.userManagement.list.searchInput")}
                />
                <div style={{ paddingLeft: "30px" }}>
                  <ButtonAdd text={t("general.add")} onClick={addUser} />
                </div>
              </div>
              <Spinner spinning={isLoadingUsers} />
              {!isLoadingUsers && (
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4
                  pagination={paginationFactory(pagination)}
                  noDataIndication={t("admin.userManagement.list.emptyTable")}
                  striped
                  hover
                />
              )}
            </div>
          )}
        </ToolkitProvider>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("general.remove")}</Modal.Title>
        </Modal.Header>
        {selectedUser !== undefined ? (
          <Modal.Body>
            {`Apagar utilizador: ${selectedUser.firstName} ${selectedUser.lastName}?`}
          </Modal.Body>
        ) : null}
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("general.back")}
          </Button>
          <Button variant="danger" onClick={() => apagarUtilizador()}>
            {t("general.remove")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withNamespaces()(UnikUserTable);
